import { AccountStatus, IAccount } from "@wingspanhq/users/dist/lib/interfaces";

export const selectorAccountDepositReady = (account: IAccount) =>
  (account.status == AccountStatus.Active ||
    account.status === AccountStatus.Pending) &&
  account.canBeUsedFor?.payments;
